module.exports = __webpack_public_path__ + "static/img/装饰6.da5f71c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/jewelryPendant/imgs/装饰6.svg
// module id = 9OTb
// module chunks = 2